/*
 * Page-scoped styles for the public registration form (ENG-4017 follow-up:
 * "Option B" visual pass). Deliberately unlayered and scoped under
 * .registration-form so they beat the unlayered .form-control rule in
 * styles/_base/forms.css — scoped here, rather than edited globally, since
 * that base style is shared by every form across the app and this pass is
 * specific to the public registration flow. Buttons on this page use
 * Components/Buttons/Button (not the .btn class), so their disabled/muted
 * treatment is handled via its `mutedDisabled` prop instead.
 */

.registration-form .form-control,
.registration-form .form-control-select {
    background-color: #fff;
    /*
     * storm-80 (the original spec here) is ~1.4:1 against this white fill --
     * with the tinted `bg-storm-90` fill gone (this page overrides it to
     * white above), the border is the *only* visual cue to a field's
     * boundary, so it needs to clear the WCAG 1.4.11 3:1 non-text minimum on
     * its own. storm-50 is the lightest token in this scale that does
     * (~3.7:1 on white).
     */
    border-color: var(--color-storm-50);
}

.registration-form .form-control:hover,
.registration-form .form-control-select:hover,
.registration-form .form-control.hover,
.registration-form .form-control-select.hover {
    border-color: var(--color-royal-20);
}

.registration-form .section-icon {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 9999px;
    background-color: var(--color-royal-50);
    color: var(--color-royal-10);
}
